/**
 * Menu translations - English
 * key = Chinese menu name from backend, value = English display text
 */
export default {
  menu: {
    '首页': 'Home',
    '个人中心': 'Profile',
    '系统管理': 'System',
    '用户管理': 'Users',
    '费用项目管理': 'Fee Items',
    '角色管理': 'Roles',
    '菜单管理': 'Menus',
    '部门管理': 'Departments',
    '操作日志': 'Audit Logs',
    '编码规则': 'Code Rules',
    '审计日志': 'Audit Trail',
    '字典管理': 'Dictionary',
    '用户权限': 'User Permissions',
    '系统日志': 'System Logs',
    '权限分配': 'Permissions',
    '组织管理': 'Organizations',
    '业态类型管理': 'Business Types',
    '业态分类': 'Business Category',
    '资产管理': 'Assets',
    '资产总览': 'Asset Overview',
    '铺位管理': 'Shops',
    '广告位管理': 'Ad Spaces',
    '共享空间': 'Shared Spaces',
    '楼层平面管理': 'Floor Plans',
    '招商管理': 'Leasing',
    '品牌管理': 'Brands',
    '商户管理': 'Merchants',
    '招商政策': 'Policies',
    '招商工作台': 'Workbench',
    '业态规划': 'Business Planning',
    '模拟落位': 'Placement',
    '品牌落位': 'Brand Placement',
    '招商洽谈': 'Negotiations',
    '招商意向': 'Intentions',
    '招商计划': 'Plans',
    '招商任务': 'Tasks',
    '正式落位': 'Formal Placement',
    '商品管理': 'Products',
    '合同管理': 'Contracts',
    '租赁合同': 'Lease Contracts',
    '合同列表': 'Contract List',
    '合同变更': 'Contract Amendment',
    '营运管理': 'Operations',
    '现场管理': 'Site Mgmt',
    '开业筹备管理': 'Opening Preparation',
    '退场管理': 'Termination Mgmt',
    '销售数据管理': 'Sales Data',
    '缴费管理': 'Payments',
    '保证金管理': 'Deposit',
    '保证金表单': 'Deposit Form',
    '账单管理': 'Bills',
    '费用录入': 'Fee Entry',
    '能源计量': 'Energy',
    '设备管理': 'Devices',
    '报表中心': 'Reports',
    '资产报表': 'Asset Reports',
    '铺位台账': 'Shop Ledger',
    '出租率分析': 'Lease Rate',
    '到期预警': 'Expiry Alert',
    '招商报表': 'Leasing Reports',
    '招商进度': 'Progress',
    '财务报表': 'Finance Reports',
    '收入月报': 'Revenue',
    '收缴预警': 'Collection',
    '报表查询': 'Reports',
    '总经理驾驶舱': 'Dashboard',
    '工作流': 'Workflow',
    '工作流程': 'Workflow',
    '待办': 'To Do',
    '待办任务': 'Todo Tasks',
    '已完成': 'Completed',
    '已办任务': 'Done Tasks',
    '已发起': 'Initiated',
    '我发起的': 'My Initiated',
    '流程定义': 'Definitions',
    '资源定价': 'Pricing',
    '打印模板管理': 'Print Templates',
    '打印模板': 'Print Templates',
    '模板设计器': 'Template Designer',
    '能源管理': 'Energy Management',
    '水电煤管理': 'Utility Meters',
    '仪表台账': 'Meter Ledger',
    '抄表管理': 'Meter Reading',
    '单价配置': 'Price Config',
    '物业管理': 'Property',
    '工单管理': 'Work Orders',
    '商户账号管理': 'Merchant Accounts',
    '通知模板': 'Notification Templates',
    '账单详情': 'Bill Detail',
    '收款登记': 'Payment Registration',
    '收款记录': 'Payment Records',
    '新增收款': 'Add Payment',
    '编辑收款': 'Edit Payment',
    '联营合同': 'Joint Contracts',
    '联营结算': 'Joint Settlement',
    '支付工具': 'Payment Instruments',
    '付款方式': 'Payment Methods',
    '付款周期管理': 'Payment Cycle',
    '收费主体': 'Billing Entity',
    '定时任务日志': 'Scheduled Task Logs',
    '凭证管理': 'Voucher Management',
    '凭证定义': 'Voucher Definition',
    '凭证字段定义': 'Voucher Field Definition',
    '凭证生成': 'Voucher Generate',
    '结转记录': 'Transfer Records',
    '科目对应': 'Subject Mapping',
    '部门对照': 'Dept Mapping',
    // Invoice
    '发票管理': 'Invoice Management',
    '开票申请': 'Invoice Application',
    '开票处理': 'Invoice Processing',
    '发票记录': 'Invoice Records',
    // Plan Management
    '计划管理': 'Plan Management',
    '年度计划': 'Annual Plan',
    '年度计划详情': 'Annual Plan Detail',
    '执行任务': 'Execution Tasks',
    '计划调整': 'Plan Adjustment',
    '计划复盘': 'Plan Review',
    '经营看板': 'Management Dashboard',
    '指标管理': 'Indicator Management',
    // Marketing
    '营销管理': 'Marketing',
    '营销活动': 'Campaigns',
    '优惠券管理': 'Coupons',
    // Asset
    '资产调整': 'Asset Adjustment',
    '资产管理首页': 'Asset Homepage',
    // System / Config
    '系统配置': 'System Config',
    '参数设置': 'Parameters',
    '权限矩阵': 'Permission Matrix',
    '合同分段配置': 'Contract Segment Config',
    '应收应付计划': 'Receivable/Payable Plan',
    // Report Sub-menus
    '总经理报表': 'GM Reports',
    '营运报表': 'Operations Reports',
    '物业报表': 'Property Reports',
    '意向转化漏斗': 'Conversion Funnel',
    '业态规划及落位分析': 'Planning & Placement Analysis',
    '品牌与业态结构': 'Brand & Category Structure',
    '销售坪效分析': 'Sales Efficiency Analysis',
    '租户异动监控': 'Tenant Change Monitoring',
    '销售额统计': 'Sales Statistics',
    '开业筹备进度': 'Opening Preparation Progress',
    '工单统计': 'Work Order Statistics',
    '工单分布': 'Work Order Distribution',
    '工单效率': 'Work Order Efficiency',
    '广告位概览': 'Advertising Overview',
    '广告位分析': 'Advertising Analysis',
    // Leasing sub-menus
    '招商资源库': 'Leasing Resources',
    '招商规划': 'Leasing Planning',
    '招商执行': 'Leasing Execution',
    '商户旅程': 'Merchant Journey',
    '洽谈明细': 'Negotiation Details',
    '意向转化': 'Intention Conversion',
    // Contract sub-menus
    '合同台账': 'Contract Ledger',
    '空置资产明细': 'Vacant Assets Detail',
    '续签预警': 'Renewal Alert',
    // Finance sub-menus
    '应收实收明细': 'Receivable & Collected Detail',
    '账龄分析': 'Aging Analysis',
    '收款对账': 'Payment Reconciliation',
    '保证金台账': 'Deposit Ledger',
    '逾期明细': 'Overdue Detail',
    // Sales & Operations sub-menus
    '销售汇总': 'Sales Summary',
    '租售比分析': 'Rent-to-Sales Analysis',
    '工单明细': 'Work Order Details',
    '能耗分摊': 'Energy Cost Allocation',
    'KPI考核报表': 'KPI Reports',
    // Plan sub-menus
    '计划执行': 'Plan Execution',
    '计划报表': 'Plan Reports',
    // Other
    '租户缴费': 'Tenant Payment',
    '登录': 'Login',
    '404': '404',
    '401': '401',
  },
}
